import React from 'react'
import clsx from 'clsx'

import styles from './header-desktop.module.scss'

interface HeaderDesktopProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string
    prefixElement?: React.ReactNode | null
    postfixElement?: React.ReactNode | null
}

export const HeaderDesktop = ({
    title,
    prefixElement = null,
    postfixElement = null,
    className,
    ...props
}: HeaderDesktopProps) => {
    return (
        <header className={clsx(styles['header-desktop'], className)} {...props}>
            {prefixElement && <div>{prefixElement}</div>}
            <h1>{title}</h1>
            {postfixElement && <div>{postfixElement}</div>}
        </header>
    )
}
